import { Chart, DoughnutController, ArcElement, CategoryScale, LinearScale, Tooltip } from "chart.js";
import { colors } from "../helpers/colors";

// Register the necessary components (Chart.js 4.x requires explicit registration)

$.onmount("[data-behavior~=donutchart]", function() {
  Chart.register(DoughnutController, ArcElement, CategoryScale, LinearScale, Tooltip);
  var labels = $(this).data("labels");
  var values = $(this).data("values");

  var data = {
    datasets: [
      {
        data: values,
        backgroundColor: colors(labels.length),
        borderColor: "#ffffff",
        borderWidth: 1,
      },
    ],
    labels: labels,
  };

  var options = {
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        callbacks: {
          label: function(context) {
            var value = context.raw;
            var total = context.dataset.data.reduce(function(sum, v) { return sum + v; }, 0);
            var percentage = total ? Math.round((value / total) * 100) : 0;
            return context.label + ": " + percentage + "%";
          },
        },
      },
    },
    layout: {
      padding: 0,
    },
    aspectRatio: 1,
  };

  var chart = new Chart($(this), {
    type: "doughnut",
    data: data,
    options: options,
  });

  $(this).data("chart", chart);
});
